import { render, staticRenderFns } from "./supervise-edit-modal.vue?vue&type=template&id=b28b36ee&"
import script from "./supervise-edit-modal.vue?vue&type=script&lang=js&"
export * from "./supervise-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "supervise-edit-modal.vue"
export default component.exports